module.exports = __webpack_public_path__ + "04_face.088c4ec3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer1/04_face.png
// module id = xGDg
// module chunks = 0